import { initAdminTheme } from './theme';

export function initWorkspaceBar(): void {
    initAdminTheme();
    initProfileMenu();
    initNotificationBellActiveState();
}

function initProfileMenu(): void {
    const root = document.querySelector<HTMLElement>('[data-nais-profile-menu]');
    if (!root) {
        return;
    }

    const button = root.querySelector<HTMLButtonElement>('.nais-workspace-bar__profile-btn');
    if (!button) {
        return;
    }

    button.addEventListener('click', (event) => {
        event.stopPropagation();
        const open = root.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    document.addEventListener('click', (event) => {
        if (!root.contains(event.target as Node)) {
            closeProfileMenu(root, button);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeProfileMenu(root, button);
        }
    });
}

function closeProfileMenu(root: HTMLElement, button: HTMLButtonElement): void {
    root.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
}

function initNotificationBellActiveState(): void {
    const bell = document.querySelector<HTMLElement>('.nais-workspace-bar__btn--notify');
    if (!bell || typeof window.naisSideDialog === 'undefined') {
        return;
    }

    let lastTrigger: Element | null = null;
    document.addEventListener(
        'click',
        (event) => {
            lastTrigger = (event.target as Element).closest('.nais-side-dialog');
        },
        true,
    );

    const dialog = window.naisSideDialog;

    dialog.on('open', () => {
        if (lastTrigger?.classList.contains('nais-workspace-bar__btn--notify')) {
            bell.classList.add('is-active');
        }
    });
    dialog.on('close', () => bell.classList.remove('is-active'));
}
